<template>
  <div class="container" :class="{ 'scrolled': isScrolled }">
    <div class="left">
      <img class="logo" src="@/assets/icon/logo.png" alt="站点logo" />
    </div>

    <!-- 汉堡菜单按钮 -->
    <div class="hamburger" :class="{ 'active': isMenuOpen }" @click.stop="toggleMenu">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>

    <!-- 移动端菜单遮罩 -->
    <div v-if="isMenuOpen && isMobile" class="menu-backdrop" @click="closeMenus"></div>

    <div class="right" :class="{ 'show': isMenuOpen }" ref="menuContainer" @click.stop>
      <ul class="right-div">
        <li class="right-div-item" v-for="item in menuList" :key="item.path">
          <router-link class="router-link-text font-color-5" :to="item.path" @click="closeMenus">
            {{ item.title }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  data() {
    return {
      isMenuOpen: false,
      isScrolled: false,
      isMobile: false,
      menuList: [
        { title: 'Notes', path: '/life' },
        { title: 'Frame', path: '/nature' },
        { title: 'Firefly', path: '/danmaku' },
        { title: 'Links', path: '/analysis' },
        { title: 'Game', path: '/mine' },
        { title: 'Travels', path: '/travels' },
        { title: 'About', path: '/home' },
        { title: 'Admin', path: '/admin' }
      ]
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },

    toggleMenu(event) {
      if (event) event.stopPropagation();
      this.isMenuOpen = !this.isMenuOpen;
    },

    closeMenus() {
      this.isMenuOpen = false;
    },

    handleScroll() {
      this.isScrolled = window.scrollY > 50;
      if (this.isMobile && this.isMenuOpen) {
        this.closeMenus();
      }
    },

    handleClickOutside(event) {
      if (!this.isMobile || !this.isMenuOpen) return;
      const menuContainer = this.$refs.menuContainer;
      const hamburger = this.$el.querySelector('.hamburger');
      const clickInMenu = menuContainer?.contains(event.target);
      const clickInHamburger = hamburger?.contains(event.target);
      if (!clickInMenu && !clickInHamburger) {
        this.closeMenus();
      }
    },

    handleResize() {
      this.checkMobile();
      if (window.innerWidth > 768) {
        this.isMenuOpen = false;
      }
    },

    handleKeydown(event) {
      if (event.key === 'Escape' && this.isMenuOpen) {
        this.closeMenus();
      }
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeydown);
  },
  watch: {
    $route() {
      if (this.isMobile && this.isMenuOpen) {
        this.closeMenus();
      }
    }
  }
}
</script>

<style scoped>
.logo {
  width: 100px;
  height: auto;
  border-radius: 10px;
}

.right-div-item {
  list-style: none;
  font-style: oblique;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Playfair Display", serif;
}

.right-div-item:hover .router-link-text {
  text-shadow: 2px 2px 4px rgba(0,0,0,0.6);
  color: var(--font-color-6);
  border-bottom: 3px solid var(--font-color-6);
}

.right-div-item a {
  text-decoration: none !important;
  vertical-align: middle;
}

.right-div {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.right {
  transition: all 0.3s ease;
  margin-right: 50px;
}

.router-link-text {
  font-weight: 500;
}

.left {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 50px;
}

.container {
  position: fixed;
  top: 0;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 1001;
  transition: background 0.6s ease;
}

.container:hover,
.container.scrolled {
  background-color: rgba(49, 48, 48, 0.8);
}

/* 汉堡菜单样式 */
.hamburger {
  display: none;
  cursor: pointer;
  padding: 10px;
  z-index: 1002;
  transition: all 0.3s ease;
}

.hamburger .line {
  width: 30px;
  height: 3px;
  background-color: hsl(30, 50%, 99%);
  margin: 7px 0;
  transition: all 0.3s ease;
}

/* 菜单遮罩层 */
.menu-backdrop {
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: calc(100vh - 50px);
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 移动端样式 */
@media only screen and (max-width: 768px) {
  .hamburger {
    display: block;
    position: absolute;
    right: 5px !important;
  }

  .router-link-text {
    color: #FFF !important;
  }

  .right {
    position: fixed;
    top: 50px;
    left: -100%;
    width: 80%;
    max-width: 320px;
    height: calc(100vh - 50px);
    background-color: rgba(0, 0, 0, 0.7);
    padding: 20px 0;
    transition: all 0.3s ease;
    z-index: 1000;
    overflow-y: auto;
  }

  .right.show {
    left: 0;
  }

  .right-div {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
  }

  .right-div-item {
    width: 100%;
    padding: 0;
    font-size: 18px;
    text-align: center;
  }

  .right-div-item a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .left {
    margin-left: 10px;
  }

  /* 汉堡动画 */
  .hamburger.active .line:nth-child(1) {
    transform: rotate(-45deg) translate(-5px, 6px);
  }
  .hamburger.active .line:nth-child(2) {
    opacity: 0;
  }
  .hamburger.active .line:nth-child(3) {
    transform: rotate(45deg) translate(-5px, -6px);
  }
}

/* 桌面端样式 */
@media only screen and (min-width: 769px) {
  .hamburger {
    display: none;
  }
  /* 使用gap替代固定宽度，解决导航拥挤 */
  .right-div {
    gap: 24px;
  }
}
</style>